import { Group, Profile } from '@witkac/kartamiejska-shared';
import { ProfileResource, profileResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł profili
 *
 * @export
 * @class ProfileModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class ProfileModule extends EntityModule<Profile, ProfileResource> {
  constructor(resource: ProfileResource) {
    super(resource);

    this.state = {
      ...this.state,
      groups: undefined
    } as any;

    const superUpdate = this.actions.update as (...args: any[]) => Promise<any>;

    this.actions = {
      ...this.actions,

      update: (context: any, ...args): Promise<any> =>
        superUpdate(context, ...args).then(result => {
          context.commit('setEntity', args);
          return this.resource.get(context.state.id).then(() => result);
        })
    };

    this.mutations = {
      ...this.mutations,

      setGroups: (localstate: any, groups: Array<Group>) => {
        localstate.groups = groups;
      }
    };
  }
}

export default new ProfileModule(profileResource);
